<div class="doc-inmate-row">
  <div class="doc-cell cell-image">
    <div class="image-container">
      <img [src]="(hideMugShots ? null : mugshotImageDetails?.imageUrls?.size320) ?? 'assets/no-image-headshot.png'"
        alt="Mugshot"
        (error)="onImageError()" />
    </div>
  </div>
  
  <div class="doc-cell cell-info">
    <div class="primary-text">{{ inmate.name.fullName }}</div>
    <div class="secondary-text">PID: {{ inmate.pid || inmate.soNumber || 'N/A' }}</div>
  </div>
  
  <div class="doc-cell cell-facility">
    <div class="primary-text">{{ locationDisplay }}</div>
  </div>
  
  <div class="doc-cell cell-status">
    <div class="status-indicator">
      <span class="status-dot" [ngClass]="statusDisplay | inmateStatusClass"></span>
      <span class="status-text" [ngClass]="statusDisplay | inmateStatusClass">{{ statusDisplay | uppercase }}</span>
    </div>
  </div>
  
  <div class="doc-cell cell-action">
    <forge-icon-button aria-label="View Inmate Details">
      <forge-icon name="keyboard_arrow_right"></forge-icon>
    </forge-icon-button>
  </div>
</div>
